<template>
  <div class="foot_main">
    <div class="footer_top w_1200">
      <!-- <div class="search_box flex">
        <p class="text">首页</p>
        <div class="seach_input flex">
          <input type="text" placeholder="输入关键词">
          <i class="el-icon-search"></i>
        </div>
      </div> -->
      <div class="cont_data flex">
        <div class="left_text">
          <p class="logo">
            <img src="@/assets/pc/head/logo.png" alt="">
          </p>
           <p class="img"><img src="@/assets/deep_text.png" alt=""></p>
        </div>
        <div class="menu_list">
        <!-- <ul class="menu_item">
          <p>学院概况</p>
          <li><a href="javascript:;">学院简介</a></li>
          <li><a href="javascript:;">学院沿革</a></li>
          <li><a href="javascript:;">学院领导</a></li>
          <li><a href="javascript:;">领导题词</a></li>
          <li><a href="javascript:;">学术交流</a></li>
        </ul> -->
        <ul class="menu_item">
          <p>学习平台</p>
          <li @click="goIndex('/course/list')"><a href="javascript:;">选课中心 </a></li>
          <li @click="goIndex('/course/liveIndex')"><a href="javascript:;">直播公开课</a></li>
          <li @click="goIndex('/course/dggj')"><a href="javascript:;">大连工匠专区</a></li>
          <li @click="goIndex('/course/jpk')"><a href="javascript:;">精品课程 </a></li>
          <li @click="goIndex('/subject/list')"><a href="javascript:;">线上专题课 </a></li>
          <li @click="goIndex('/offline_course/list')"><a href="javascript:;">线下专题课</a></li>
        </ul>
        <ul class="menu_item">
          <p>创新工作</p>
          <li @click="goIndex('/achievement/index')"><a href="javascript:;">创新成果</a></li>
          <li @click="goIndex('/studio/list')"><a href="javascript:;">创新工作室</a></li>
          <li @click="goIndex('/project/index')"><a href="javascript:;">创新项目</a></li>
          <li @click="goIndex('/gjrc/list')"><a href="javascript:;">工匠人才</a></li>
          <li @click="goIndex('/problem/index')"><a href="javascript:;">疑难攻关</a></li>
        </ul>
        <ul class="menu_item">
          <p>技能竞赛</p>
          <li @click="goIndex('/skills/index')"><a href="javascript:;">技能竞赛</a></li>
        </ul>
        
      </div>
      </div>
      
    </div>
    <div class="copy_code_box">
      <div class="copy_code w_1200">
        <div class="left_text flex">
          <!-- <p>©2023 大连技术有限公司</p> -->
          <p>Copyright © 2015-2025 kjcxchina.com All Rights Reserved | 京ICP备16012224号</p>
          <p>技术支持：中工科创</p>
        </div>
        <!-- <div class="right_menu flex">
          <p>
            <a href="javascript:;">联系我们</a>
          </p>
          <p>
            <a href="javascript:;">法律声明</a>
          </p>
          <p>
            <a href="javascript:;">隐私政策</a>
          </p>
          <p>
            <a href="javascript:;">除名查询</a>
          </p>
        </div> -->
      </div>
    </div>

    <!-- 右侧固定导航 -->
    <div
      v-if="fixedState"
      class="fixed_menu"
      :class="goTopShow ? 'goTop' : 'fixed_menu'"
    >

      <ul class="cont_ul">
        <li class="code_li">
          <p class="icon"><img src="@/assets/pc/index/right_icon1.png" alt=""></p>
          <p class="text">扫码咨询</p>
          <div class="show_cont_info code_info">
            <p class="tips">扫码加微信咨询</p>
            <p class="img"><img src="@/assets/pc/index/right_code.png" alt=""></p>
          </div>
        </li>
        <li class="phone_li">
          <p class="icon"><img src="@/assets/pc/index/right_icon2.png" alt=""></p>
          <p class="text">咨询建议</p>
          <div class="show_cont_info phone_cont" >
            <p class="phone">电话：400-0123-823</p>
          </div>
        </li>
        
        <li @click="goTopBtn()">
          <p class="icon"><img src="@/assets/pc/index/right_icon3.png" alt=""></p>
          <p class="text">顶部</p>
        </li>
      </ul>
    </div>
 
  </div>
</template>

<script>
export default {
  name: "HelloWorld",
  data() {
    return {
      dataInfo: "",
      maskState: false,
      goTopShow: false,
      fixedState: true,
    };
  },
  props: {
    deepLogoUrl: {
      type: String,
      default: "",
    },
    maskState1: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    $route: {
      handler(newVal) {
        const { rightIsShow } = newVal.meta;
        this.fixedState = rightIsShow ? true : false;
      },
      immediate: true,
    },
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  methods: {
    goIndex(url){
      this.$router.push(url)
    },
     // 回到顶部
     handleScroll() {
      this.scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (this.scrollTop > 200) {
        this.goTopShow = true;
      } else {
        this.goTopShow = false;
      }
    },
     //回到顶部
     goTopBtn() {
      let timer = null,
        _that = this;
      cancelAnimationFrame(timer);
      timer = requestAnimationFrame(function fn() {
        if (_that.scrollTop > 0) {
          _that.scrollTop -= 250;
          document.body.scrollTop = document.documentElement.scrollTop =
            _that.scrollTop;
          timer = requestAnimationFrame(fn);
        } else {
          cancelAnimationFrame(timer);
          _that.goTopShow = false;
        }
      });
    },
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>

<style scoped lang="scss">
.foot_main {
  width: 100%;
  // height: 395px;
  background: #F2F2F2;
  // margin-top: 120px;
  .footer_top {
    padding: 70px 0 30px;
   
    .search_box{
      justify-content: space-between;
      border-bottom: 1px solid #E2E2E2;
      padding-bottom: 12px;
      p.text{
        font-size: 15px;
        color: #333333;
      }
      .seach_input{
          width: 507px;
          height: 45px;
          background: #FFFFFF;
          border: 1px solid #D4D4D4;
          justify-content: space-between;
          box-sizing: border-box;
          padding: 0 20px;
          i{
            border-left: 1px solid #D4D4D4;
            padding-left: 20px;
            font-size: 20px;
          }
      }
    }
    .cont_data{
      align-items: flex-start;
      justify-content: space-between;
      .left_text{
        width: 300px;
        //  margin-top: 25px;
        p.logo{
          width:210px;
          img{
            width: 100%;
            height: auto;
          }
        }
        p.img{
          width: 213px;
          margin-top: 17px;
          border-top:1px solid #E2E2E2 ;
          padding-top: 17px;
          img{
            width: 100%;
            height:21px;
          }
        }
        p.text{
          border-top: 1px solid #E2E2E2;
          margin-top: 14px;
          padding-top:14px ;
          font-size: 16px;
          font-family: PingFang SC-Bold, PingFang SC;
          font-weight: bold;
          color: #333333;
          line-height: 24px;
          display: flex;
          justify-content: space-between;
        }
      }
    }
    .menu_list{
      // margin-top: 25px;
       display: flex;
    justify-content: center;
      ul{
        margin-right: 200px;
        p{
          font-size: 16px;
          font-weight: bold;
          color: #333333;
          margin-bottom: 21px;
        }
        li{
          margin-bottom: 20px;
          font-size: 14px;
        }
      }
      ul:last-child{
        margin-right: 0;
      }
    }
  }
  .copy_code_box{
    background: #E6E6E6;
    padding:  10px 0;
    .copy_code{
      width: 900px;
      display: flex;
      p,a{
        font-size: 14px;
        color: #333333;
      }
      .left_text{
        margin-right: 27px;
        p:last-child{
          margin-left: 19px;
        }
      }
      .right_menu{
        border-left: 1px solid #C2C3C3;
        padding-left: 26px;
        p{
          margin-right: 26px;
        }
      }
    }
  }
}
.fixed_menu {
    // flex: 1;
    position: fixed;
    top: 50%;
    right: 0;
    // left: 50%;
    // margin-left: 614px;
    // position: fixed;
    // top: 50%;
    // right:15%;
    z-index: 9;
    transform: translateY(-50%);
    transition: all .5s  ease-in-out;
    // ul {
    //   li {
    //     width: 70px;
    //     height: 70px;
    //     background: #ffffff;
    //     box-shadow: 0px 2px 10px 1px rgba(0, 0, 0, 0.05);
    //     border-radius: 3px 3px 3px 3px;
    //     margin-bottom: 12px;
    //     display: flex;
    //     flex-direction: column;
    //     justify-content: center;
    //     align-items: center;
    //     cursor: pointer;
    //     p.text {
    //       font-size: 14px;
    //       font-family: Source Han Sans CN-Regular, Source Han Sans CN;
    //       font-weight: 400;
    //       color: #333;
    //       text-align: center;
    //       a{
    //         color:#333;
    //       }
    //     }
    //     img{
    //       width: 100%;
    //       height: 100%;
    //       border-radius: 3px;
    //     }
    //     p.img2 {
    //       display: none;
    //     }
    //     transition: 0.8s;
    //     &:hover {
    //       p.text {
    //         color: #0676fe;
    //         a{
    //           color: #0676fe;
    //         }
    //       }
    //     }
    //     .show_text {
    //       width: 440px;
    //       min-height: 206px;
    //       background: #ffffff;
    //       box-shadow: 0px 4px 7px 1px rgba(20, 6, 5, 0.16);
    //       border-radius: 4px;
    //       position: absolute;
    //       right: 73px;
    //       top: 0;
    //       z-index: 13px;
    //       display: none;
    //       .title_icon {
    //         display: flex;
    //         align-items: center;
    //         padding: 21px;
    //         span {
    //           font-size: 22px;
    //           font-family: Source Han Sans CN;
    //           font-weight: 500;
    //           color: #254ed4;
    //           margin-left: 10px;
    //         }
    //       }
    //       .phone_list {
    //         background: #e5eaef;
    //         padding-bottom: 15px;
    //         display: flex;
    //         min-height: 132px;
    //         .left_text {
    //           padding-top: 32px;
    //           margin-left: 20px;
    //         }
    //         p.text1 {
    //           font-size: 18px;
    //           font-family: Source Han Sans CN;
    //           font-weight: 500;
    //           color: #222222;
    //           margin-bottom: 11px;
    //         }
    //         div.num {
    //           font-size: 14px;
    //           font-family: Source Han Sans CN;
    //           font-weight: 500;
    //           color: #254ed4;
    //           margin-bottom: 5px;
    //           span {
    //             color: #222;
    //             margin-right: 10px;
    //           }
    //         }
    //       }
    //       .code_img {
    //         width: 120px;
    //         height: 120px;
    //          margin-left: 22px;
    //           margin-top: 31px;
    //         img{
    //           width: 100%;
    //           height: auto;
             
    //       }
    //       }
    //     }
    //   }
    //   li.show_more:hover .show_text {
    //     display: block;
    //   }

    //   p.goHeader {
    //     width: 70px;
    //     height: 34px;
    //     background: #ffffff;
    //     box-shadow: 0px 2px 10px 1px rgba(0, 0, 0, 0.05);
    //     border-radius: 3px 3px 3px 3px;
    //     text-align: center;
    //     line-height: 34px;
    //     font-size: 12px;
    //     font-family: Source Han Sans CN-Regular, Source Han Sans CN;
    //     font-weight: 400;
    //     color: #000000;
    //   }
    // }

    .cont_ul{
      width: 80px;
      // height: 298px;
      background: #FFFFFF;
      opacity: 1;
      border: 1px solid #F4F4F5;
      padding-top: 15px;
      border-radius: 10px 0 0 10px;
      li{
        margin: 0 14px;
        margin-bottom: 13px;
        padding-bottom: 15px;
        border-bottom: 1px solid #D8D8D8;
        position: relative;
        cursor: pointer;
        p.icon{
          width: 30px;
          height: 30px;
          margin: 0 auto;
          img{
            width: 100%;
            height: auto;
          }
        }
        p.text{
          font-size: 12px;
          font-family: Source Han Sans, Source Han Sans;
          font-weight: 400;
          color: #0080FF;
          margin-top: 4px;
          text-align: center;
        }
        .show_cont_info{
          position: absolute;
          
        }
        .code_info{
          left: -200px;
          top: -12px;
          width: 180px;
          height: 193px;
          background: #FFFFFF;
          box-sizing: border-box;
          padding: 24px 34px 0;
          border-radius: 10px;
          display: none;
          p.tips{
            text-align: center;
            font-size: 16px;
            font-family: Source Han Sans, Source Han Sans;
            font-weight: 400;
            color: #3D3D3D;
          }
          p.img{
            width: 112px;
            height: 111px;
            img{
              width: 100%;
            }
          }
        }
        .phone_cont{
          left: -260px;
          top: -8px;
          border-radius: 10px;
          display: none;
          width: 240px;
          height: 81px;
          background: #FFFFFF;
          text-align: center;
          line-height: 81px;
          font-size: 20px;
          font-family: Source Han Sans, Source Han Sans;
          font-weight: 500;
          color: #333333;
        }

      }
      li.code_li:hover{
        .code_info{
          display: block;
        }
      }
      li.phone_li:hover{
        .phone_cont{
          display: block;
        }
      }
      li:last-child{
        border-bottom: none;
      }
    }
  }
  .goTop {
    top: 30%;
  }
</style>
